import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const regions = [
  {
    id: "us",
    name: "United States",
    flag: "https://flagcdn.com/w80/us.png",
    active: true,
    vendor: "JM Bullion",
    vendorPath: "/retailers/jm-bullion",
  },
  {
    id: "ca",
    name: "Canada",
    flag: "https://flagcdn.com/w80/ca.png",
    active: true,
    vendor: "TD",
    vendorPath: "/retailers/td",
  },
  {
    id: "uk",
    name: "United Kingdom",
    flag: "https://flagcdn.com/w80/gb.png",
    active: false,
    vendor: null,
    vendorPath: null,
  },
  {
    id: "au",
    name: "Australia",
    flag: "https://flagcdn.com/w80/au.png",
    active: false,
    vendor: null,
    vendorPath: null,
  },
  {
    id: "eu",
    name: "European Union",
    flag: "https://flagcdn.com/w80/eu.png",
    active: false,
    vendor: null,
    vendorPath: null,
  },
];

export const RegionGateway = () => {
  const [selectedRegion, setSelectedRegion] = useState("us");

  return (
    <div 
      className="region-gateway py-2 md:py-2.5 bg-black/95 backdrop-blur-sm"
      data-testid="region-gateway"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center gap-2 md:gap-3">
          <p className="ticker-text text-center text-[0.55rem] md:text-[0.65rem] hidden md:block">
            Goldnote sells through select online retailers; please click your region here:
          </p>
          
          <div className="flex items-center gap-3 md:gap-5">
            <TooltipProvider delayDuration={0}>
              {regions.map((region) => (
                <Tooltip key={region.id}>
                  <TooltipTrigger asChild>
                    {region.active && region.vendorPath ? (
                      <Link
                        to={region.vendorPath}
                        onClick={() => setSelectedRegion(region.id)}
                        className={`flex flex-col items-center gap-0.5 md:gap-1 group`}
                        data-testid={`flag-${region.id}`}
                        aria-label={region.name}
                      >
                        <div className={`flag-button ${selectedRegion === region.id ? 'active' : ''}`}>
                          <img 
                            src={region.flag} 
                            alt={region.name}
                            loading="lazy"
                            className="w-6 h-4 md:w-8 md:h-5 object-cover rounded-sm"
                          />
                        </div>
                        <span className="text-[0.45rem] md:text-[0.5rem] tracking-wider uppercase text-[#D4AF37]/70 group-hover:text-[#D4AF37] transition-colors whitespace-nowrap">
                          {region.vendor}
                        </span>
                      </Link>
                    ) : (
                      <div 
                        className="flex flex-col items-center gap-0.5 md:gap-1 opacity-50 cursor-not-allowed"
                        data-testid={`flag-${region.id}`}
                      >
                        <div className="flag-button grayscale">
                          <img 
                            src={region.flag} 
                            alt={region.name}
                            loading="lazy"
                            className="w-6 h-4 md:w-8 md:h-5 object-cover rounded-sm"
                          />
                        </div>
                        <span className="text-[0.45rem] md:text-[0.5rem] tracking-wider uppercase text-white/30 whitespace-nowrap">
                          Soon
                        </span>
                      </div>
                    )}
                  </TooltipTrigger>
                  <TooltipContent 
                    side="bottom" 
                    className="bg-[#0A0A0A] border border-[#B08D1A] text-[#D4AF37] px-3 py-2 hidden md:block"
                  >
                    <p className="text-xs tracking-wider uppercase">
                      {region.active ? `${region.name} - ${region.vendor}` : `${region.name} - Coming Soon`}
                    </p>
                  </TooltipContent>
                </Tooltip>
              ))}
            </TooltipProvider>
          </div>
        </div>
      </div>
    </div>
  );
};
